import Reveal from '@/components/base/Reveal';

export default function CtaBand() {
  return (
    <section className="bg-background-50 pb-14 pt-2 md:pb-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-12 md:px-12 md:py-16">
            <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-400/30 blur-2xl" />
            <div className="pointer-events-none absolute -bottom-20 left-1/3 h-56 w-56 rounded-full bg-secondary-400/25 blur-3xl" />

            <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
              <div className="lg:col-span-8">
                <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                  关注你喜欢的主播，随时掌握开播动态
                </h2>
                <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
                  下载糖豆视频，高颜值小姐姐、女神级主播每日开播提醒不错过，
                  精彩短视频与直播内容同步更新，让你一次看个够。
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row lg:col-span-4 lg:flex-col lg:items-stretch">
                <a
                  href="#top"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100 md:text-base"
                >
                  <i className="ri-download-2-line" />
                  下载糖豆视频
                </a>
                <a
                  href="#live"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 md:text-base"
                >
                  <i className="ri-live-line" />
                  先逛逛正在开播
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}